import logoImage from '../resources/Terral_Logo.png';
import titleImage from '../resources/Terral_Title.png';
import abuelaImage from '../resources/abuela.webp';
import gitanaImage from '../resources/gitana.webp';
import frikiImage from '../resources/friki.webp';
import tpvImage from '../resources/TPV.webp';
import gatoImage from '../resources/gato.webp';
import pezImage from '../resources/pez.webp';
import fachaImage from '../resources/facha.webp';
import machoImage from '../resources/macho.webp';
import perfilDaniImage from '../resources/PerfilDani.webp';
import perfilPabloImage from '../resources/PerfilPablo.webp';
import perfilJaviImage from '../resources/PerfilJavi.webp';
import perfilNoeliaImage from '../resources/PerfilNoelia.webp';
import dibujoNoeliaImage from '../resources/DibujoNoelia.webp';
import placeholderImage from '../resources/abuela.webp';
 
export const IMAGE_PATHS = {
    LOGO: logoImage,
    TITLE: titleImage,
    ABUELA: abuelaImage,
    GITANA: gitanaImage,
    FRIKI: frikiImage,
    TPV: tpvImage,
    GATO: gatoImage,
    PEZ: pezImage,
    FACHA: fachaImage,
    MACHO: machoImage,
    PERFIL_DANI: perfilDaniImage,
    PERFIL_PABLO: perfilPabloImage,
    PERFIL_JAVI: perfilJaviImage,
    PERFIL_NOELIA: perfilNoeliaImage,
    DIBUJO_NOELIA: dibujoNoeliaImage,
    DIBUJO_JAVI: require('../resources/DibujoJavi.webp'), // Assuming this is a local image
    DIBUJO_PABLO: require('../resources/DibujoPablo.webp'), // Assuming this is a local image
    DIBUJO_DANI: require('../resources/DibujoDani.webp'), // Assuming this is a local image
    PLACEHOLDER: placeholderImage,
    // Add more image paths here as needed
} as const; 